import { Box, Grid, styled, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import React from 'react';
import { CalendarDayColumn } from './calendar-day-column';
import { useGetVisibleDays } from '../../hooks/use-get-visible-days';

type CalendarJobTypeProps = {
  jobType?: {
    id: string;
    name: string;
    shifts: {
      applicants: number;
      claimants: number;
      jobName: string;
      flexPoolOnly: boolean;
      dateLabel: string;
      dateTime: string;
      endTime: string;
      id: string;
      maxClaimants: number;
      startTime: string;
      hasCanceledClaim: boolean;
    }[];
  };
};

export const CalendarJobType = React.memo(
  ({ jobType }: CalendarJobTypeProps) => {
    const { visibleDays } = useGetVisibleDays();

    return (
      <JobWrapper>
        <JobName title={jobType ? jobType.name : ''}>{jobType ? jobType.name : null}</JobName>
        <JobShiftGrid container flexWrap={'nowrap'}>
          {visibleDays.map((date) => {
            const columnData = jobType
              ? jobType.shifts.filter(
                  (shift) =>
                    DateTime.fromISO(shift.dateTime).toFormat('dd-LL') ===
                    DateTime.fromISO(date).toFormat('dd-LL')
                )
              : [];

            return <CalendarDayColumn key={date} data={columnData} dayCount={visibleDays.length} />;
          })}
        </JobShiftGrid>
      </JobWrapper>
    );
  },
  (prev, next) => {
    if (prev.jobType?.id !== next.jobType?.id) {
      return false;
    }
    if (prev.jobType?.shifts.length !== next.jobType?.shifts.length) {
      return false;
    }
    for (let i = 0; i < (prev.jobType?.shifts.length ?? 0); i++) {
      if (prev.jobType?.shifts[i].id !== next.jobType?.shifts[i].id) {
        return false;
      }
      if (JSON.stringify(prev.jobType?.shifts[i]) !== JSON.stringify(next.jobType?.shifts[i])) {
        return false;
      }
    }
    return true;
  }
);

const JobWrapper = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  display: 'flex',
}));

const JobShiftGrid = styled(Grid)({
  '& > .MuiGrid-item:nth-child(2n - 1)': {
    background: 'white',
  },
});

const JobName = styled(Typography)(({ theme }) => ({
  width: '14vw',
  padding: theme.spacing(2, 2, 2, 0),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flex: 'none',
  whiteSpace: 'nowrap',
}));
